var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7783 3H4.22165C2.99466 3 2 3.95942 2 5.14293L2.0018 18.8571C2.0018 20.0406 2.99646 21 4.22345 21H12.7801C14.0071 21 15.0018 20.0406 15.0018 18.8571L15.0018 13.0022H7.92623C7.51722 13.0022 7.18566 12.6824 7.18566 12.2879C7.18566 11.8934 7.51722 11.5736 7.92623 11.5736H15.0018V12.9837H20.3875L17.8652 15.3367C17.5785 15.6135 17.5785 16.0523 17.8652 16.3292C18.1591 16.6129 18.644 16.6208 18.9483 16.3467L22.778 12.7752C22.849 12.7087 22.9052 12.6298 22.9435 12.543C23.0619 12.2764 22.9966 11.9695 22.778 11.7651L18.9482 8.1936C18.6536 7.93561 18.1948 7.93544 17.9 8.19326C17.5914 8.4631 17.5758 8.91516 17.8652 9.20291L20.3875 11.5552H15.0018L15 5.14293C15 3.95942 14.0053 3 12.7783 3Z",
    fill: "#B2B2BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogOut);
export default __webpack_public_path__ + "static/media/icon-log-out.f6dcf0a6c041315722d883e7f8fafb35.svg";
export { ForwardRef as ReactComponent };